// extracted by mini-css-extract-plugin
export var childrenContainer = "_8n-0";